import { render, staticRenderFns } from "./GoalItem.vue?vue&type=template&id=15a7cdaa&scoped=true"
import script from "./GoalItem.vue?vue&type=script&lang=js"
export * from "./GoalItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a7cdaa",
  null
  
)

export default component.exports